import { combineEpics } from 'redux-observable';
// import userProjectEpic from './userProject/userProjectEpic';

// const rootEpic = combineEpics(userProjectEpic);
const rootEpic = combineEpics();
export default rootEpic;
